// import 'whatwg-fetch';
import * as types from '../constants/action-types';
import { HistoryItem, defaultTemplate } from '../utils/templateHistory';
import { ASSETS_TYPE } from '../utils/templateHistoryTypes';

let serverUrl = (process.env.NODE_ENV === 'production' ? 'https://networthly-api.fly.dev' : 'http://localhost:8000');

function fetchAllHistory () {
  return fetch(`${serverUrl}/api/v1/history`, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('id_token'),
      'Content-Type': 'application/json'
    },
  })
}

export function fetchHistory() {
  return (dispatch) => {
    dispatch({ type: types.FETCH_HISTORY_REQUEST });

    fetchAllHistory()
      .then((resp) => resp.json())
      .then((history) => {
        if (history === null) throw new Error('No history')
        if (history.length === 0) return dispatch({ type: types.UI_SHOW_DUMBLEDORE });

        dispatch({
          type: types.FETCH_HISTORY_SUCCESS,
          payload: { history: history.map(HistoryItem.deserialize) },
        });

        return history.map(HistoryItem.deserialize)
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_HISTORY_FAILURE, payload: error });
      })
  };
}

export function createHistoryItem(historyItem) {
  return (dispatch) => {
    fetch(`${serverUrl}/api/v1/history`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(historyItem),
    })
      .then((resp) => resp.json())
      .then((history) => dispatch(fetchHistory()))
  }
}

export function createAccount(accountGroupId) {
  return (dispatch, getState) => {
    dispatch({ type: types.CREATE_ACCOUNT_REQUEST })
    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex]

    currentHistoryCopy
      .findGroupById(accountGroupId)
      .addGenericAccount('', '')

    const serializedHistory = currentHistoryCopy.serialize()

    fetch(`${serverUrl}/api/v1/history/${serializedHistory._id}`, {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(serializedHistory),
    })
      .then((resp) => resp.json())
      .then((updatedHistoryItem) => {
        dispatch({
          type: types.UPDATE_HISTORY_ITEM,
          payload: { updatedHistoryItem: HistoryItem.deserialize(updatedHistoryItem), currentHistoryIndex },
        });
      })
  }
}

export function updateAccount(groupId, updatedAccount) {
  return (dispatch, getState) => {
    dispatch({ type: types.UPDATE_ACCOUNT_REQUEST })
    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex]

    // update history with updated account details
    currentHistoryCopy
      .updateAccount(groupId, updatedAccount);

    const serializedHistory = currentHistoryCopy.serialize()
    fetch(`${serverUrl}/api/v1/history/${serializedHistory._id}`, {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(serializedHistory),
    })
      .then((resp) => resp.json())
      .then((updatedHistoryItem) => {
        dispatch({
          type: types.UPDATE_HISTORY_ITEM,
          payload: { updatedHistoryItem: HistoryItem.deserialize(updatedHistoryItem), currentHistoryIndex },
        });
      })
  }
}

export function deleteAccount(groupId, updatedAccount) {
  return (dispatch, getState) => {
    dispatch({ type: types.DELETE_ACCOUNT_REQUEST })
    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex]

    console.log(currentHistoryCopy)

    // update history with updated account details
    currentHistoryCopy
      .deleteAccount(groupId, updatedAccount)

    const serializedHistory = currentHistoryCopy.serialize()
    fetch(`${serverUrl}/api/v1/history/${serializedHistory._id}`, {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(serializedHistory),
    })
      .then((resp) => resp.json())
      .then((updatedHistoryItem) => {
        dispatch({
          type: types.UPDATE_HISTORY_ITEM,
          payload: { updatedHistoryItem: HistoryItem.deserialize(updatedHistoryItem), currentHistoryIndex },
        });
      })
  }
}

export function deleteHistoryItem(historyItemId) {
  return (dispatch, getState) => {
    console.log('currentHistoryIndex', historyItemId)
    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex]
    const serializedHistory = currentHistoryCopy.serialize()
    fetch(`${serverUrl}/api/v1/history/${serializedHistory._id}`, {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(serializedHistory),
    })
    .then(() => {
      fetchAllHistory()
        .then((resp) => resp.json())
        .then((allHistory) => {

          dispatch({
            type: types.FETCH_HISTORY_SUCCESS,
            payload: { history: allHistory.map(HistoryItem.deserialize) },
          });

          if (allHistory === null) throw new Error('No history')
          if (allHistory.length === 0) return dispatch({ type: types.UI_SHOW_DUMBLEDORE });

        })
        .catch((error) => {
          dispatch({ type: types.FETCH_HISTORY_FAILURE, payload: error });
        })
    })
  }
}

export function cloneToDate(selectedDate) {
  return (dispatch, getState) => {
    console.log(getState().history.history[0])
    const currentHistoryIndex = getState().history.currentHistoryIndex
    console.log('CURRENT HISTORY INDEX', currentHistoryIndex)
    const currentHistoryCopy = getState().history.history[currentHistoryIndex].cloneToDate(selectedDate).serialize()

    fetch(`${serverUrl}/api/v1/history`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(currentHistoryCopy),
    })
      .then((resp) => resp.json())
      .then((savedClonedHistoryItem) => {
        fetchAllHistory()
          .then((resp) => resp.json())
          .then((allHistory) => {
            const currentHistoryIndex = allHistory.map((historyItem) => historyItem._id).indexOf(savedClonedHistoryItem._id)

            dispatch({
              type: types.CLONE_HISTORY_SUCCESS,
              payload: { history: allHistory.map(HistoryItem.deserialize), currentHistoryIndex },
            })
          })
          .catch((error) => {
            dispatch({ type: types.FETCH_HISTORY_FAILURE, payload: error });
          })
      })
  }
}

export function createGroup(groupType) {
  return (dispatch, getState) => {
    dispatch({ type: types.CREATE_GROUP_REQUEST });

    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex].clone()

    if (groupType === ASSETS_TYPE) {
      currentHistoryCopy.assetGroup('New Group', true);
    } else {
      currentHistoryCopy.liabilitiesGroup('New Group', true);
    }

    console.log(currentHistoryCopy.serialize());

    updateHistoryItem(dispatch, currentHistoryCopy, currentHistoryIndex);
  }
}

export function updateGroupName(groupId, groupName) {
  console.log('updateGroupNameAction', groupId, groupName)
  return (dispatch, getState) => {
    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex].clone()
    currentHistoryCopy.updateGroupName(groupId, groupName)
    updateHistoryItem(dispatch, currentHistoryCopy, currentHistoryIndex);
  }
}


export function updateGroup(groupId) {
}



export function deleteGroup(groupId, groupType) {
  return (dispatch, getState) => {
    const currentHistoryIndex = getState().history.currentHistoryIndex
    const currentHistoryCopy = getState().history.history[currentHistoryIndex].clone()
    const isAssets = getState().ui.isAssets

    if (groupType === 'assets') {
      currentHistoryCopy.deleteAssetGroup(groupId)
    } else {
      currentHistoryCopy.deleteLiabilitiesGroup(groupId)
    }

    updateHistoryItem(dispatch, currentHistoryCopy, currentHistoryIndex);
  }
}

function updateHistoryItem(dispatch, historyItem, currentHistoryIndex) {
  const serializedHistory = historyItem.serialize()
  return fetch(`${serverUrl}/api/v1/history/${serializedHistory._id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('id_token')}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(serializedHistory),
  })
    .then(resp => resp.json())
    .then((updatedHistoryItem) => {
      dispatch({
        type: types.UPDATE_HISTORY_ITEM,
        payload: { updatedHistoryItem: HistoryItem.deserialize(updatedHistoryItem), currentHistoryIndex },
      });
    })
}



// WEBPACK FOOTER //
// ./src/actions/history-actions.js